/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { REPORTCONFIGURATION } from './rEPORTCONFIGURATION';


export interface REPORT {
    /**
     * Start date for the report. If empty, means that user is interested in the report from the very begining of operations. The data is defined in the format yyyyMMdd'T'HHmmssX in accordance with ISO 8601 
     */
    startDate?: string;
    /**
     * End date for the report. If empty, means that user is interested in the report up to the current time. Please note, that current time is fixed at the moment of the API call. Events that have occured during the report generation won't be available within the report. The data is defined in the format yyyyMMdd'T'HHmmssX in accordance with ISO 8601 
     */
    endDate?: string;
    /**
     * Report file location 
     */
    location?: string;
    configuration: REPORTCONFIGURATION;
    /**
     * Status of the report
     */
    status: REPORT.StatusEnum;
    /**
     * original request ID for the one time reports
     */
    id?: string;
}
export namespace REPORT {
    export type StatusEnum = 'OK' | 'FAILED' | 'RUNNING' | 'PENDING';
    export const StatusEnum = {
        OK: 'OK' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        RUNNING: 'RUNNING' as StatusEnum,
        PENDING: 'PENDING' as StatusEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/rEPORT.ts